import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LS = {
  tenantKey: "gvi_tenant_key",
  tenantName: "gvi_tenant_name",
  adminKey: "gvi_admin_key",
  persona: "gvi_persona",
  chatModel: "gvi_chat_model",
};

export const pub = axios.create({ baseURL: API });

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  cfg.headers["X-Admin-Key"] = localStorage.getItem(LS.adminKey) || "";
  return cfg;
});

export const tenantApi = axios.create({ baseURL: API });
tenantApi.interceptors.request.use((cfg) => {
  cfg.headers["X-Tenant-Key"] = localStorage.getItem(LS.tenantKey) || "";
  return cfg;
});

// Streaming chat via fetch + ReadableStream (SSE-style).
export async function streamChat(body, handlers) {
  const { onMeta, onSources, onToken, onDone, onError } = handlers || {};
  let resp;
  try {
    resp = await fetch(`${API}/chat/stream`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Tenant-Key": localStorage.getItem(LS.tenantKey) || "",
      },
      body: JSON.stringify(body),
    });
  } catch (e) {
    onError && onError("Network error contacting the memory engine.");
    return;
  }
  if (!resp.ok) {
    let detail = `Request failed (${resp.status})`;
    try {
      const j = await resp.json();
      detail = j.detail || detail;
    } catch (_) {}
    onError && onError(detail);
    return;
  }
  const reader = resp.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buffer.indexOf("\n\n")) >= 0) {
      const chunk = buffer.slice(0, idx).trim();
      buffer = buffer.slice(idx + 2);
      if (!chunk.startsWith("data:")) continue;
      const data = chunk.slice(5).trim();
      try {
        const ev = JSON.parse(data);
        if (ev.type === "meta") onMeta && onMeta(ev);
        else if (ev.type === "sources") onSources && onSources(ev.sources);
        else if (ev.type === "token") onToken && onToken(ev.content);
        else if (ev.type === "error") onError && onError(ev.content);
        else if (ev.type === "done") onDone && onDone(ev);
      } catch (_) {}
    }
  }
  onDone && onDone({});
}
